import ToastHighLighter from '@/lib/ToastHighLighter';

export const Video169Code = () => {
  const language = 'html';
  const codeString = `
  // 16:9
  <div class="ratio ratio-16x9">
    <iframe
      src="https://www.youtube.com/embed/HVpIwFu6lIc?si=fjSFfn8pQE_T8s38"
      title="YouTube video"
      allowFullScreen
    ></iframe>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'video169'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const Video219Code = () => {
  const language = 'html';
  const codeString = `
  // 21:9
  <div class="ratio ratio-21x9">
    <iframe
      src="https://www.youtube.com/embed/HVpIwFu6lIc?si=fjSFfn8pQE_T8s38"
      title="YouTube video"
      allowFullScreen
    ></iframe>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'video219'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const Video43Code = () => {
  const language = 'html';
  const codeString = `
  // 4:3
  <div class="ratio ratio-4x3">
    <iframe
      src="https://www.youtube.com/embed/HVpIwFu6lIc?si=fjSFfn8pQE_T8s38"
      title="YouTube video"
      allowFullScreen
    ></iframe>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'video43'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};

export const Video11Code = () => {
  const language = 'html';
  const codeString = `
  // 1:1
  <div class="ratio ratio-1x1">
    <iframe
      src="https://www.youtube.com/embed/HVpIwFu6lIc?si=fjSFfn8pQE_T8s38"
      title="YouTube video"
      allowFullScreen
    ></iframe>
  </div>
  `;

  return (
    <>
      <ToastHighLighter
        name={'video11'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
